import React from 'react';

interface SkeletonBoxProps {
  classname: string;
  index?: number;
}

const SkeletonBox: React.FC<SkeletonBoxProps> = ({ classname, index }) => {
  return (
    <div
      key={index || 1}
      className={`${classname} rounded-[23px] animate-pulse bg-[#c9c9c9]`}
    />
  );
};

export default SkeletonBox;